import SkillCss from './Skill.css'
interface IProps {
	name?: string
}
export default function SkillTag({ name }: IProps) {
	return <SkillCss>{name}</SkillCss>
}
